
import { useSelector } from "react-redux";
import { VENDOR_PROFILE_DETAILS_REQUEST, VENDOR_PROFILE_DETAILS_FAIL, VENDOR_PROFILE_DETAILS_SUCCESS } from "../constants/AuthConstant"

const id = localStorage.getItem("vendorid");

const axios = require("axios");

export const VendorProfile = (vId) => {
  return function (dispatch) {
    dispatch({
      type: VENDOR_PROFILE_DETAILS_REQUEST,
      payload: true,
    });
    const vendorID= vId? vId:id;
    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/get_vendor_by_vendorId?vendorId=${vendorID}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    axios(OPTION)
      .then((res) => {
        // console.log(res.data, "hello")
        dispatch(loadAllDetailsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: VENDOR_PROFILE_DETAILS_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
      });
  };
};

export const loadAllDetailsPre = (data) => {
  return {
    type: VENDOR_PROFILE_DETAILS_SUCCESS ,
    result: data,
    payload: false,
    loading: false,
    msg: "SUCCESS",
  };
};